module.exports = __webpack_public_path__ + "img/access.2fdab857.png";